<template>
    <div class="dashboard">
        <h1>ドライバー一覧</h1>
        <div class="l-mb4">
            <router-link class="button--oval--primary" :to="{ name: 'offices_drivers_create' }">新しいドライバーを登録する</router-link>
        </div>
        <MasterList :list="list" />
        <Modal :modal="modal" @action="modalAction($event)" @close="$_modalClose()" />
    </div>
</template>

<script>
    "use strict";

    import common from "@/mixins/common";
    import MasterList from "@/components/MasterList.vue";

    const tableDrivers = [
        {
            "class": "",
            "head": "ドライバーID",
            "key": "driver_id",
        },
        {
            "class": "",
            "head": "ドライバー名",
            "key": "driver_name",
        },
        {
            "class": "is-right",
            "head": "通常出社時間",
            "key": "work_time",
        },
    ];

    export default {
        "components": {
            MasterList,
        },
        "mixins": [
            common,
        ],
        data() {
            return {
                "list": {
                    "normalize": tableDrivers,
                    "data": [],
                    "update": {
                        "link": {
                            "name": "offices_drivers_update",
                            "params": "driver_id",
                        },
                    },
                },
            };
        },
        created() {
            this.fetchingListDrivers();
        },
        "methods": {
            fetchingListDrivers() {
                // 全ドライバーデータ取得
                common.$_axios.get(
                    `${common.$_configs.apiUrl}/drivers`,
                    this.$_requestConfig()
                ).then(response => {
                    // ドライバーIDで昇順
                    this.list.data = response.data.sort((a, b) => a.driver_id - b.driver_id);
                }).catch(() => {
                    this.$_modalError("fetchingDriversError");
                });
            },
        },
    };
</script>
